import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ProjectService } from '../../services/project.service';
import { StorageService } from '../../../Common/services/storage.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GinfoProjectDetailsVm, MasterStatusList, ProjectStatus, ProjectVm, ReviewComments, FundingAndRMS } from '../../models/project-vm';
import { Router } from '@angular/router';
import { MessageService } from '../../services/message.service';
import { RefTypeEnum } from '../../enums/ref-type-enum';
import { UserLogin } from '../../../Common/models/user.login';
import { ProjectApproval, ReviewLogDto, SalesPlanVm } from '../../models/salesplan-vm';
import { WizardStatus } from '../../../Common/Constants/common.constants';
import { UserRoleServiceService } from '../../../shared/services/user-role-service.service';
import { ApprovalConstants, RolesKeysConstants } from '../../../Common/Constants/data';
import { CustomEncodeDecodeService } from '../../../Common/services/custom-encode-decode.service';
import { ConfirmationService } from 'primeng/api';
import { ProjectConstants } from '../../constants/component-messages';
import { UnsavedChangesService } from '../../../unsaved-changes.service';

interface Status {
  statusID: number;
  statusName: string;
}

interface StatusMapping {
  [key: string]: {
    id: number;
    color: string;
  };
}

@Component({
  selector: 'app-common-approval',
  templateUrl: './common-approval.component.html',
  styleUrl: './common-approval.component.css'
})
export class CommonApprovalComponent {

  //@Input() selectedApproval: ProjectVm | null | undefined;
  @Input() allStatusList: MasterStatusList[] | null | undefined;
  @Input() selApprovalVM: ProjectApproval | null | undefined;
  @Input() selProjectStatus: ProjectStatus | null | undefined;
  @Input() projectId: number | null | undefined;
  @Input() categoryid: number | null | undefined;
  @Input() disableAll: boolean = false;
  @Input() componentUsedBy: RefTypeEnum = RefTypeEnum.None;
  @Input() disableAfterReview: boolean = false;
  @Output() notifyBubbleStatus: EventEmitter<{}> = new EventEmitter<{}>();
  @Output() notifyReadyForReviewClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() emitKeyValueChangesAfterReviewRequest = new EventEmitter<string>();

  @Input() projectStatusList: ProjectStatus[] | null | undefined;
  @Input() selectedFundingRMS: FundingAndRMS | null | undefined;

  uInfo: UserLogin | null | undefined;
  statusDisplay: string = '';
  statusDisplayClass: string = '';
  enableDisableReviewButton: boolean = true;
  enableDisableApproveButton: boolean = true;
  processProjectStatus: ProjectStatus | null | undefined;
  isUserCanReview: boolean = false;
  isUserCanApprove: boolean = false;
  disableApprove: boolean = false;
  disableReviewforSRE: boolean = false;
  classCursor: string = 'cur-pointer';
  encodedprojectId: any;
  encodedcategoryid: any;
  showLockIcon: boolean = false;
  isCheckedLockedIcon: boolean=false;
  isDisableLockIcon:boolean=true;
  lockedUnlockedMsg?: string;
  reviewComments:string='';
  showReviewLogs:boolean=false;
  reviewLogs:ReviewLogDto[]=[];

  constructor(private projectService: ProjectService,
    private storageService: StorageService,
    private msgService: MessageService,
    private ngxService: NgxUiLoaderService,
    private router: Router,
    private userRoleService: UserRoleServiceService,
    private encodeDecodeService: CustomEncodeDecodeService,
    private confirmationService: ConfirmationService, private cdr: ChangeDetectorRef,
    private unsavedChangesService: UnsavedChangesService
  ) {
    
  }

  async ngOnInit() {
    this.uInfo = this.storageService.getItem<UserLogin>("UserInfo");
    this.selProjectStatus = new ProjectStatus();
    this.processProjectStatus = new ProjectStatus();
    this.isUserCanReview = await this.userRoleService.canRequestForReview();
    this.isUserCanApprove = await this.userRoleService.canApprove();
    //if(this.userRoleService.role?.roleID==4){
    if (this.userRoleService.role?.roleKey == RolesKeysConstants.RoleKey_CustomerTeam || this.userRoleService.role?.write == false) {
      this.disableApprove = true;
      this.disableReviewforSRE = false;
      if (this.selApprovalVM) {
        this.selApprovalVM.isDisbleApprovalsBtns = true;
        //this.selApprovalVM.isDisbleReviewComments = true;
      }
      if(this.userRoleService.role?.write == false){
        this.disableReviewforSRE= true;
      }
      if (this.selApprovalVM && this.userRoleService.role?.write == false) {
        this.selApprovalVM.isDisbleReviewRequestBtn = true;
      }
      if(this.selApprovalVM && this.disableAll && this.userRoleService.role?.roleKey == RolesKeysConstants.RoleKey_CustomerTeam ){
        this.selApprovalVM.isDisbleReviewRequestBtn = true;
      }
      if(this.selApprovalVM){
      if(this.selApprovalVM.approvalStage==ApprovalConstants.Approval_Approved || this.selApprovalVM.approvalStage==ApprovalConstants.Approval_LOCKED)
        {
          this.selApprovalVM.isDisbleReviewRequestBtn = true;
        } else {
          this.selApprovalVM.isDisbleReviewRequestBtn = false;
        }
      }

    } else if (this.userRoleService.role?.roleKey == RolesKeysConstants.RoleKey_SREAdmin || 
      (this.userRoleService.role?.roleKey== RolesKeysConstants.RoleKey_SRESupport 
        && this.userRoleService.role?.write == true)) {
      this.disableReviewforSRE = true;
      this.isDisableLockIcon=false;
      this.disableApprove = false;
      if (this.selApprovalVM && this.selApprovalVM.refID) {
        this.selApprovalVM.isDisbleReviewRequestBtn = false;
        if(this.selApprovalVM.approvalStage==ApprovalConstants.Approval_Approved || this.selApprovalVM.approvalStage==ApprovalConstants.Approval_LOCKED)
          {
            this.selApprovalVM.isDisbleReviewRequestBtn = true;
          } else {
            this.selApprovalVM.isDisbleReviewRequestBtn = false;
          }
        
      }
    }
    
    this.getReviewLogs();
  }

  async ngOnChanges(changes: SimpleChanges) {
   
    if (changes['selApprovalVM']) {

      if (this.selApprovalVM == null && this.selApprovalVM == undefined) {
        //this.selApprovalVM = new ProjectApproval();
      }
      else {

        let ctRole = (await this.userRoleService.getUserRoles())
                    .some(role => role.roleKey.includes(RolesKeysConstants.RoleKey_CustomerTeam));
        
        if ((ctRole && this.selApprovalVM.approvalStage == null) || this.userRoleService.role?.write == false) {
          this.disableApprove = true;
          this.disableReviewforSRE = false;
          if (this.selApprovalVM) {
            this.selApprovalVM.isDisbleApprovalsBtns = true;
            //this.selApprovalVM.isDisbleReviewComments = true;
           
          }
          if(this.userRoleService.role?.write == false){
            this.disableReviewforSRE= true;
          }
          if (this.selApprovalVM && this.userRoleService.role?.write == false) {
            this.selApprovalVM.isDisbleReviewRequestBtn = true;
          }
          if(this.selApprovalVM && this.disableAll && this.userRoleService.role?.roleKey == RolesKeysConstants.RoleKey_CustomerTeam ){
            this.selApprovalVM.isDisbleReviewRequestBtn = true;
          }
          if(this.selApprovalVM.approvalStage==ApprovalConstants.Approval_Approved || this.selApprovalVM.approvalStage==ApprovalConstants.Approval_LOCKED)
            {
              this.selApprovalVM.isDisbleReviewRequestBtn = true;
            } else {
              this.selApprovalVM.isDisbleReviewRequestBtn = false;
            }

    
        } else if (this.userRoleService.role?.roleKey == RolesKeysConstants.RoleKey_SREAdmin || 
          (this.userRoleService.role?.roleKey== RolesKeysConstants.RoleKey_SRESupport 
            && this.userRoleService.role?.write == true)){
          this.disableReviewforSRE = true;
          this.isDisableLockIcon=false;
          this.disableApprove = false;
          if (this.selApprovalVM) {
            // if(this.selApprovalVM.approvalStatus == "ACTION REQUIRED")
            // {
            //   this.selApprovalVM.isDisbleReviewRequestBtn = false;
            // }
            // else
            // {
              this.selApprovalVM.isDisbleReviewRequestBtn = false;
            //}
            if(this.selApprovalVM.approvalStage==ApprovalConstants.Approval_Approved || this.selApprovalVM.approvalStage==ApprovalConstants.Approval_LOCKED)
            {
              this.selApprovalVM.isDisbleReviewRequestBtn = true;
            }
          }
        }
       
        if(this.selApprovalVM.approvalStage==ApprovalConstants.Approval_Approved || this.selApprovalVM.approvalStage==ApprovalConstants.Approval_LOCKED
          || this.selApprovalVM.approvalStage==ApprovalConstants.Approval_UNLOCKED){
            this.showLockIcon=true;
          }
          if(this.selApprovalVM.approvalStage==ApprovalConstants.Approval_Approved || this.selApprovalVM.approvalStage==ApprovalConstants.Approval_LOCKED){
              this.isCheckedLockedIcon=true;
            }
            if ( this.selProjectStatus?.statusID == 1  || this.selApprovalVM.approvalStage==ApprovalConstants.Approval_ACTIONREQUIRED) {
             // this.enableDisableReviewButton = false;
             this.selApprovalVM!.isDisbleReviewRequestBtn = false;
            if (this.userRoleService.role?.roleKey== RolesKeysConstants.RoleKey_SRESupport 
              && this.userRoleService.role?.write == false){
                this.selApprovalVM!.isDisbleReviewRequestBtn = true;
              }
            }
            else {
             // this.enableDisableReviewButton = true;
              this.selApprovalVM!.isDisbleReviewRequestBtn = true;
            }

        if (this.selApprovalVM.isReviewClicked && this.selProjectStatus?.statusID == 2) {
          if (this.isUserCanApprove) {
            this.enableDisableApproveButton = false;

            if (this.enableDisableApproveButton) {
              this.classCursor = 'cur-pointer';
            }
            else {
              this.classCursor = 'cur-hand';
            }
          }
          else {
            this.enableDisableApproveButton = true;
            this.classCursor = 'cur-pointer';
          }
        }
        else {
          this.enableDisableApproveButton = true;
          this.classCursor = 'cur-pointer';
        }
      }

    }

    if (changes['projectId']) {
      this.encodedprojectId = this.encodeDecodeService.encode(this.projectId);
      this.encodedcategoryid = this.encodeDecodeService.encode(this.categoryid);
      if (this.projectId != null && this.projectId != undefined && this.projectId > 0) {
        this.getReviewLogs();
        if ( this.selProjectStatus?.statusID == 1 || this.selApprovalVM!.approvalStage==ApprovalConstants.Approval_ACTIONREQUIRED) {
         // this.enableDisableReviewButton = false;
         this.selApprovalVM!.isDisbleReviewRequestBtn = false;
         if (this.userRoleService.role?.roleKey== RolesKeysConstants.RoleKey_SRESupport 
          && this.userRoleService.role?.write == false){
            this.selApprovalVM!.isDisbleReviewRequestBtn = true;
          }
        }
        else {
         // this.enableDisableReviewButton = true;
          this.selApprovalVM!.isDisbleReviewRequestBtn = true;
        }
      } else {
       // this.selApprovalVM = new ProjectApproval();
       if(this.selApprovalVM==null){
        this.selApprovalVM = new ProjectApproval();
        this.selApprovalVM!.isDisbleReviewRequestBtn = true;
        this.selApprovalVM!.isDisbleApprovalsBtns = true;
        this.selApprovalVM!.isDisbleReviewComments = true;
       }
        
        
      }

    }

    if (changes['projectStatusList']) {

      if (this.projectStatusList != null
        && this.projectStatusList != undefined
      ) {
        //console.log('projectStatusList', this.projectStatusList);
      }

    }

    if (changes['selProjectStatus']) {
      if (this.selProjectStatus != null|| this.selProjectStatus != undefined
      ) {
        if (this.selProjectStatus.statusID! >= 2 && this.selApprovalVM?.isReviewClicked
        ) {
          this.statusDisplay = "Pending";
          this.statusDisplayClass = "text-warning";
        }
        else if (this.selProjectStatus.statusID! >= 2 && this.selApprovalVM?.isApproveClicked
        ) {
          this.statusDisplay = "Approved";
          this.statusDisplayClass = "text-success";
        }
      }
      
    }
    // if (changes['selProjectStatus']) {
    //   if(this.selProjectStatus == null
    //     || this.selProjectStatus == undefined
    //   )
    //   {
    //     this.selProjectStatus = new ProjectStatus();
    //   }

    //   // if(this.selProjectStatus!=null)
    //   // {
    //   //   if(this.selProjectStatus.statusID == 1)
    //   //   {
    //   //     this.statusDisplay = '';
    //   //   }
    //   //   else if(this.selProjectStatus.statusID == 2)
    //   //   {
    //   //     if(this.selApprovalVM?.isReviewClicked)
    //   //     {
    //   //       this.statusDisplay = 'Pending';
    //   //     }
    //   //     else if(this.selApprovalVM?.isApproveClicked)
    //   //     {
    //   //       this.statusDisplay = 'Approved';
    //   //     }
    //   //   }
    //   // }
    // }
    // if (changes['selProjectStatus'] && this.selProjectStatus !== null) {

    //   console.log('projectApproal-projectstatus-', this.selProjectStatus);
    //   if(this.selProjectStatus == null
    //     && this.selProjectStatus == undefined
    //   )
    //   {
    //     this.selProjectStatus = new ProjectStatus();
    //   }
    // }
  }

  readyForReviewConfirmation(){  
    if(!this.unsavedChangesService.hasUnsaved){   
    this.confirmationService.confirm({
      message: 'Are you sure you want to request for review?',
      accept: () => {
        //this.readyForReviewClick();   
        this.doValidateBeforeReview();    
      },
      reject: () => {
        
      }
    });
  } else {
    return confirm("You have unsaved changes Kindly save it");
  }
  return true;

  }

  doValidateBeforeReview(){
      this.notifyReadyForReviewClicked.emit('');
  }

  readyForReviewClick(): void {

    this.ngxService.start();
    let actionRequiredApprovalVM = new ProjectApproval();
    actionRequiredApprovalVM.refID = this.projectId;

    actionRequiredApprovalVM.type = this.componentUsedBy;
    actionRequiredApprovalVM.approvedBy = this.uInfo?.userID;
    actionRequiredApprovalVM.approvedDate = new Date();
    actionRequiredApprovalVM.isReviewClicked = true;
    actionRequiredApprovalVM.isApproveClicked = false;
    actionRequiredApprovalVM.requestedDate = new Date(actionRequiredApprovalVM.requestedDate!);
    actionRequiredApprovalVM.actionBy = this.uInfo?.userEmail;
    actionRequiredApprovalVM.requestedBy = this.uInfo?.userID;
    actionRequiredApprovalVM.approvalStage=ApprovalConstants.Approval_RequestForReview;

    this.processProjectStatus!.changedBy! = this.uInfo!.userID;
    this.processProjectStatus!.changedDate! = new Date();
    this.processProjectStatus!.refID! = this.projectId!;
    this.processProjectStatus!.type! = this.componentUsedBy;

    if (this.componentUsedBy == RefTypeEnum.Project) {
      let projectModel = new ProjectVm();
      projectModel.projectApproval = actionRequiredApprovalVM;
      projectModel.projectStatus = this.processProjectStatus!;   
      this.reviewApprovalProcess(projectModel, ApprovalConstants.Approval_RequestForReview);    
    }
    else if (this.componentUsedBy == RefTypeEnum.Sales) {
      let salesModel = new SalesPlanVm();
      salesModel.projectApproval = actionRequiredApprovalVM;
      salesModel.projectStatus = this.processProjectStatus!;
      //this.salesReviewApiCall(salesModel);
      this.reviewApprovalProcess(salesModel, ApprovalConstants.Approval_RequestForReview);
    }
  }

  approvedForReviewConfirmation(){

    if (this.selectedFundingRMS ?.fundingType == 1) {
      if (this.selectedFundingRMS ?.sreReviewed == null
        || this.selectedFundingRMS ?.sreReviewed == undefined
          || !this.selectedFundingRMS ?.sreReviewed
    ) {
        this.msgService.htmlError(ProjectConstants.FUNDING_RMS_KEY_JTBD_Required);
        return;
      }
    }

    this.confirmationService.confirm({
      message: 'Are you sure you want to Approve?',
      accept: () => {
        this.approvedForReviewClick();       
      },
      reject: () => {
        
      }
    });
  }

  approvedForReviewClick(): void {
    this.ngxService.start();

    let actionRequiredApprovalVM = new ProjectApproval();
    actionRequiredApprovalVM.refID = this.projectId;

    actionRequiredApprovalVM.type = this.componentUsedBy;
    actionRequiredApprovalVM.approvedBy = this.uInfo?.userID;
    actionRequiredApprovalVM.approvedDate = new Date();
    actionRequiredApprovalVM.isReviewClicked = false;
    actionRequiredApprovalVM.isApproveClicked = true;
    actionRequiredApprovalVM.approvalStage=ApprovalConstants.Approval_Approved;
    actionRequiredApprovalVM.requestedDate = new Date(actionRequiredApprovalVM.requestedDate!);
    actionRequiredApprovalVM.actionBy = this.uInfo?.userEmail;

    this.processProjectStatus!.changedBy! = this.uInfo!.userID;
    this.processProjectStatus!.changedDate! = new Date();
    this.processProjectStatus!.refID! = this.projectId!;
    this.processProjectStatus!.statusID! = 2;
    this.processProjectStatus!.type! = this.componentUsedBy;

    // projectModel.generalInfo.projectDetails = new GinfoProjectDetailsVm();
    // projectModel.generalInfo.projectDetails.projectId! = this.projectId!;
    // projectModel.generalInfo.projectDetails.type = this.componentUsedBy!;  

    if (this.componentUsedBy == RefTypeEnum.Project) {
      let projectModel = new ProjectVm();
      projectModel.projectApproval = actionRequiredApprovalVM;
      projectModel.projectStatus = this.processProjectStatus!;
      //this.projectApprovalAPiCall(projectModel);
      this.reviewApprovalProcess(projectModel, ApprovalConstants.Approval_Approved);
    }
    else if (this.componentUsedBy == RefTypeEnum.Sales) {
      let salesModel = new SalesPlanVm();
      salesModel.projectApproval = actionRequiredApprovalVM;
      salesModel.projectStatus = this.processProjectStatus!;
      //this.salesApprovalAPiCall(salesModel);
      this.reviewApprovalProcess(salesModel, ApprovalConstants.Approval_Approved);
    }

  }

  actionRequiredConfirmation(){
    this.confirmationService.confirm({
      message: 'Are you sure you want to Action required?',
      accept: () => {
        this.actionRequiredClick();       
      },
      reject: () => {
        
      }
    });
  }

  actionRequiredClick(): void {
    this.ngxService.start();
    let actionRequiredApprovalVM = new ProjectApproval();
    actionRequiredApprovalVM.refID = this.projectId;

    actionRequiredApprovalVM.type = this.componentUsedBy;
    actionRequiredApprovalVM.approvedBy = this.uInfo?.userID;
    actionRequiredApprovalVM.approvedDate = new Date();
    actionRequiredApprovalVM.isReviewClicked = false;
    actionRequiredApprovalVM.isApproveClicked = false;
    actionRequiredApprovalVM.requestedDate = new Date(actionRequiredApprovalVM.requestedDate!);
    actionRequiredApprovalVM.actionBy = this.uInfo?.userEmail;
    actionRequiredApprovalVM.approvalStage=ApprovalConstants.Approval_ACTIONREQUIRED;

    this.processProjectStatus!.changedBy! = this.uInfo!.userID;
    this.processProjectStatus!.changedDate! = new Date();
    this.processProjectStatus!.refID! = this.projectId!;
    this.processProjectStatus!.statusID! = 2;
    this.processProjectStatus!.type! = this.componentUsedBy;

    // projectModel.generalInfo.projectDetails = new GinfoProjectDetailsVm();
    // projectModel.generalInfo.projectDetails.projectId! = this.projectId!;
    // projectModel.generalInfo.projectDetails.type = this.componentUsedBy!;  

    if (this.componentUsedBy == RefTypeEnum.Project) {
      let projectModel = new ProjectVm();
      projectModel.projectApproval = actionRequiredApprovalVM;
      projectModel.projectStatus = this.processProjectStatus!;
      //this.projectApprovalAPiCall(projectModel);
      this.reviewApprovalProcess(projectModel, ApprovalConstants.Approval_ACTIONREQUIRED);
    }
    else if (this.componentUsedBy == RefTypeEnum.Sales) {
      let salesModel = new SalesPlanVm();
      salesModel.projectApproval = actionRequiredApprovalVM;
      salesModel.projectStatus = this.processProjectStatus!;
      //this.salesApprovalAPiCall(salesModel);
      this.reviewApprovalProcess(salesModel, ApprovalConstants.Approval_ACTIONREQUIRED);
    }

  }

  reviewApprovalProcess(modelDetails: any, isReview: string) {
    this.projectService.saveUpdateReviewApproval(modelDetails, this.componentUsedBy).subscribe({
      next: (projectId) => {
        // handle value
        this.getReviewLogs();
        if (isReview==ApprovalConstants.Approval_RequestForReview) {
          this.msgService.htmlSuccess("Requested review was successfull");
          //if(!this.selApprovalVM?.isReviewRequestCompleted){
            this.emitKeyValueChangesAfterReviewRequest.emit('');
         // }
        }
        else if (isReview==ApprovalConstants.Approval_ACTIONREQUIRED) {
          this.msgService.htmlSuccess("Approval status updated as Action Required successfully");
        }
        else if(isReview==ApprovalConstants.Approval_LOCKED){
          this.msgService.htmlSuccess("Locked successfully");
        }
        else if(isReview==ApprovalConstants.Approval_UNLOCKED){
          this.msgService.htmlSuccess("UnLocked successfully");
        }
        else {
          this.msgService.htmlSuccess("Project has been successfully approved");
        }

        let statusBUbble = this.setWizardStatus(this.selProjectStatus!,
          this.selApprovalVM!!);

        this.ngxService.stop();

        this.notifyBubbleStatus.emit(statusBUbble);
        if(this.componentUsedBy == RefTypeEnum.Project)
          {
            this.router.navigate(['/projectintake/editproject',  this.encodedprojectId,this.encodedcategoryid]);
          }
         if(this.componentUsedBy == RefTypeEnum.Sales)
          {
            this.router.navigate(['/projectintake/editsalesplan',  this.encodedprojectId,this.encodedcategoryid]);
          }
      
      },
      error: (error) => {
        this.ngxService.stop();
        // handle error
        //this.msgService.htmlError(error.message);
      },
      complete: () => {
        // handle complete
      }
    });
  }





  // projectReviewApiCall(projectDetails: ProjectVm){
  //   this.projectService.saveUpdateApprovalFromProject(projectDetails).subscribe({
  //     next: (projectId) => {
  //       // handle value
  //       this.msgService.htmlSuccess("Requested review was successfull");

  //       let statusBUbble = this.setWizardStatus(this.selProjectStatus!, 
  //         this.selApprovalVM!!);            

  //       this.ngxService.stop();

  //       this.notifyBubbleStatus.emit(statusBUbble);
  //       //this.router.navigate(['/projectintake/editproject', projectId]);
  //     },
  //     error: (error) => {
  //       this.ngxService.stop();
  //       // handle error
  //       //this.msgService.htmlError(error.message);
  //     },
  //     complete: () => {
  //       // handle complete
  //     }
  //   });
  // }

  // projectApprovalAPiCall(projectDetails: ProjectVm){
  //   this.projectService.saveUpdateApprovalFromProject(projectDetails!).subscribe({
  //     next: (projectId) => {
  //       // handle value
  //       this.msgService.htmlSuccess("Approval was successfull");
  //       //this.router.navigate(['/projectintake/editproject', projectId]);

  //       let statusBUbble = this.setWizardStatus(this.selProjectStatus!, 
  //         this.selApprovalVM!);            

  //       this.ngxService.stop();

  //       this.notifyBubbleStatus.emit(statusBUbble);
  //     },
  //     error: (error) => {
  //       this.ngxService.stop();
  //       // handle error
  //       //this.msgService.htmlError(error.message);
  //     },
  //     complete: () => {
  //       // handle complete
  //     }
  //   });
  // }


  // salesReviewApiCall(salesplanModel: SalesPlanVm){
  //   this.projectService.saveUpdateApprovalFromSalesPlan(salesplanModel).subscribe({
  //     next: (projectId) => {
  //       // handle value
  //       this.msgService.htmlSuccess("Requested review was successfull");

  //       let statusBUbble = this.setWizardStatus(this.selProjectStatus!, 
  //         this.selApprovalVM!!);            

  //       this.ngxService.stop();

  //       this.notifyBubbleStatus.emit(statusBUbble);
  //       //this.router.navigate(['/projectintake/editproject', projectId]);
  //     },
  //     error: (error) => {
  //       this.ngxService.stop();
  //       // handle error
  //       //this.msgService.htmlError(error.message);
  //     },
  //     complete: () => {
  //       // handle complete
  //     }
  //   });
  // }

  // salesApprovalAPiCall(salesplanModel: SalesPlanVm){
  //   this.projectService.saveUpdateApprovalFromSalesPlan(salesplanModel!).subscribe({
  //     next: (projectId) => {
  //       // handle value
  //       this.msgService.htmlSuccess("Approval was successfull");
  //       //this.router.navigate(['/projectintake/editproject', projectId]);

  //       let statusBUbble = this.setWizardStatus(this.selProjectStatus!, 
  //         this.selApprovalVM!);            

  //       this.ngxService.stop();

  //       this.notifyBubbleStatus.emit(statusBUbble);
  //     },
  //     error: (error) => {
  //       this.ngxService.stop();
  //       // handle error
  //       //this.msgService.htmlError(error.message);
  //     },
  //     complete: () => {
  //       // handle complete
  //     }
  //   });
  // }

  // getStatusColors(statusId: number, statusList:any[], masterStatusList: any[], 
  //   projetApproval: ProjectApproval) {


  //   return finalResult;
  // }


  private constructStatusMapping(projectStatus: ProjectStatus[],
    masterStatus: MasterStatusList[], projetApproval: ProjectApproval): void {
    let finalResult: any = {};
    let lastStsIndex = 0;
    masterStatus.forEach((x, index) => {

      if (projectStatus == null
        || projectStatus == undefined
        || projectStatus.length <= 0
      ) {
        finalResult[x.statusName!.replace(' ', '') + "_step"] = "";
      }
      else {
        let matchedStatus = projectStatus.filter(y => y.statusID == x.statusID);

        if (matchedStatus == null
          || matchedStatus == undefined
          || matchedStatus.length <= 0
        ) {
          if (lastStsIndex + 1 == x.statusID) {
            finalResult[x.statusName!.replace(' ', '') + "_step"] = '';
          }
          else {
            finalResult[x.statusName!.replace(' ', '') + "_step"] = "";
          }
        }
        else {
          if (x.statusID == 2 && projetApproval.approvalStage == ApprovalConstants.Approval_Approved) {
            finalResult[x.statusName!.replace(' ', '') + "_step"] = WizardStatus.ACTIVE;
            lastStsIndex = x.statusID;
          }
          else if (x.statusID == 2 && (projetApproval.approvalStage == ApprovalConstants.Approval_ACTIONREQUIRED
            || projetApproval.approvalStage == ApprovalConstants.Approval_RequestForReview)
          ) {
            finalResult[x.statusName!.replace(' ', '') + "_step"] = WizardStatus.ONACTION;
          }
          else {
            finalResult[x.statusName!.replace(' ', '') + "_step"] = WizardStatus.ACTIVE;
            lastStsIndex = x.statusID!;
          }
        }
      }

    });
    return finalResult;
  }

  setWizardStatusNew(projectStatus: ProjectStatus[], masterStatus: MasterStatusList[],
    projetApproval: ProjectApproval
  ) {
    
    let displayBubbles = this.constructStatusMapping(projectStatus, masterStatus, projetApproval);
    return displayBubbles;
  }

  setWizardStatus(projectStatus: ProjectStatus, projetApproval: ProjectApproval) {
    let statusBubbles = {
      initiated: '',
      approved: '',
      pwrlinked: '',
      executionstarted: '',
      executioncompleted: '',
      verified: ''
    };

    // if(projectStatus.statusID == 1)
    // {
    //   statusBubbles.initiated = WizardStatus.ACTIVE;
    // }

    // if(projectStatus.statusID == 2)
    // {
    //   statusBubbles.initiated = WizardStatus.ACTIVE;

    //   if(projetApproval.isApproveClicked)
    //   {
    //     statusBubbles.approved = WizardStatus.ACTIVE;
    //   }
    //   else if(projetApproval.isReviewClicked)
    //   {
    //     statusBubbles.approved = WizardStatus.ONACTION;
    //   }
    // }
    return statusBubbles;
  }

  actionRequiredForReviwClick() {

  }

  lockedUnLockedControls(aStage?:string){
    if(aStage){

        this.ngxService.start();

      let actionRequiredApprovalVM = new ProjectApproval();
      actionRequiredApprovalVM.refID = this.projectId;

      actionRequiredApprovalVM.type = this.componentUsedBy;
      actionRequiredApprovalVM.approvedBy = this.uInfo?.userID;
      actionRequiredApprovalVM.approvedDate = new Date();
      actionRequiredApprovalVM.isReviewClicked = false;
      actionRequiredApprovalVM.isApproveClicked = true;
      actionRequiredApprovalVM.approvalStage=aStage;
      actionRequiredApprovalVM.requestedDate = new Date(actionRequiredApprovalVM.requestedDate!);
      actionRequiredApprovalVM.actionBy = this.uInfo?.userEmail;

      this.processProjectStatus!.changedBy! = this.uInfo!.userID;
      this.processProjectStatus!.changedDate! = new Date();
      this.processProjectStatus!.refID! = this.projectId!;
      this.processProjectStatus!.statusID! = 2;
      this.processProjectStatus!.type! = this.componentUsedBy;

      if (this.componentUsedBy == RefTypeEnum.Project) {
        let projectModel = new ProjectVm();
        projectModel.projectApproval = actionRequiredApprovalVM;
        projectModel.projectStatus = this.processProjectStatus!;
        //this.projectApprovalAPiCall(projectModel);
        this.reviewApprovalProcess(projectModel, aStage);
      }
      else if (this.componentUsedBy == RefTypeEnum.Sales) {
        let salesModel = new SalesPlanVm();
        salesModel.projectApproval = actionRequiredApprovalVM;
        salesModel.projectStatus = this.processProjectStatus!;
        this.reviewApprovalProcess(salesModel, aStage);
      }
    }
  }

  lockedUnLockedConfirmation(data:ProjectApproval){
   if(data.approvalStage==ApprovalConstants.Approval_UNLOCKED){
      this.lockedUnlockedMsg=ApprovalConstants.Approval_LOCKED
    }else{
      this.lockedUnlockedMsg=ApprovalConstants.Approval_UNLOCKED
    }
    this.lockedUnLockedControls(this.lockedUnlockedMsg);
  }

  submitComments(){
    if(this.reviewComments){
      let comment=new ReviewComments();
      comment.comment=this.reviewComments;
      comment.refID=this.projectId??undefined;
      comment.commentedBy = this.uInfo?.userEmail;
      comment.refID! = this.projectId!;
      comment.type! = this.componentUsedBy;  
      this.projectService.addComments(comment).subscribe(x => {
        this.reviewComments='';
        this.msgService.htmlSuccess("Comment was submitted successfully");
        this.getReviewLogs();
      });
    }else{
      this.msgService.htmlError('Please enter review comment');
    }
  }

  getReviewLogs() {
    if (this.projectId != null && this.projectId != 0 && this.componentUsedBy != null) {
      this.projectService.getReviewLogs(this.projectId, this.componentUsedBy).subscribe(x => {
        this.reviewLogs = [];
        this.reviewLogs = x;
        this.showReviewLogs=this.reviewLogs.length>0?true:false;
      });
    } 
  }
  
  
}
